

// Payment Plans
export const getPlans = () => ({
  type: 'GET_PLANS'
});

// Get Current Plan
export const getCurrentPlan = () => ({
  type: 'GET_CURRENT_PLAN'
});

// Get Credit Packages
export const getCreditPackages = () => ({
  type: 'GET_CREDIT_PACKAGES'
});

// Client Portal Session
export const createPortalSession = () => ({
  type: 'CREATE_PORTAL_SESSION'
});

// Client Portal Session
export const createCheckoutSession = (payload) => ({
  payload,
  type: 'CREATE_CHECKOUT_SESSION',
});

// Get Payments
export const getPayments = () => ({
  type: 'GET_PAYMENTS'
});

// Get Usage Metrics
export const getUsageMetrics = (payload) => ({
  payload,
  type: 'GET_USAGE_METRICS',
});

// Cancel Scheduled Plan Change
export const cancelScheduledPlanChange = (payload) => ({
  payload,
  type: 'CANCEL_SCHEDULED_PLAN_CHANGE',
});

// Verify a completed Stripe checkout session and sync subscription to DB
export const verifyCheckoutSession = (payload) => ({
  payload,
  type: 'VERIFY_CHECKOUT_SESSION',
});
